<template>
    <div class="OtherChat">
      <div class="other_user">
        <div class="name">{{ name }}</div>
        <div class="user_main">
          
          <div class="avatar_warp">
            <avatar :src="avatar" />
          </div>
          <div>
            <div class="time">{{ time }}</div>
            <div class="geo"  v-if="message.msg_type === 'location'">
              <!-- 地图信息 -->
              <geo-element :message="message"></geo-element>
            </div>
            <div class="user_message" v-else>
              <div v-if="msg_type === 'text'">
                  <div v-if="con.indexOf('/emoji')===-1">{{ con }}</div>
                  <div v-else v-html="con" class="emoji"></div>
              </div>
              <div v-else-if="msg_type === 'image'">
                  <img :src="con" alt="" style="width: 100px; height: auto;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import GeoElement from '@/components/pc/message/message-elements/geo-element.vue'

  export default {
    name: "OtherChat",
    components: {
        GeoElement
    },
    props: {
      time: {
        type: String,
        default: "",
      },
      avatar: {
        type: String,
        default: "",
      },
      con: {
        type: String,
        default: "",
      },
      name: {
        type: String,
        default: "",
      },
      msg_type: {
        type: String,
        default: "text",
      },
      message: {
      type: Object,
      required: true
    },
    },
  };
  </script>
  
  <style scoped>

  .time {
    text-align: left;
    color: #9a9a9a;
    padding-bottom: 10px;
    margin-left: 10px;
  }
  .other_user {
    padding-bottom: 30px;
  }
  .user_main {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .user_message {
    /* display: inline-block; */
    padding: 5px 16px;
    border-radius: 20px;
    color: #000;
    background-color: #ededed;
    line-height: 25px;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
    margin-left: 12px;
  }
  .name {
    margin-left: 2px;
    margin-bottom: 5px;
    font-weight: bold;
    font-style: 14px;
  }
  </style>
  
  